import React from 'react';
import PropTypes from 'prop-types';

import { PropTypesRepo } from '../functions/_propTypes';

import Input from './Input';
import Icon from './Icon';

const Textarea = React.forwardRef((props, ref) => <Input ref={ref} tag="textarea" {...props} />);

/* eslint-disable react/require-default-props */

Textarea.propTypes = {
	children: PropTypes.node,
	// mostly Icon
	prefix: PropTypes.node,
	isLoading: PropTypes.bool,
	loadingIcon: PropTypes.node,
	// mostly Icon
	suffix: PropTypes.node,
	flexGrow: PropTypesRepo.flexGrow,
	order: PropTypesRepo.order,
	tag: PropTypes.string,
	pos: PropTypesRepo.pos,
	d: PropTypesRepo.d,
	p: PropTypesRepo.p,
	rounded: PropTypesRepo.rounded,
	border: PropTypesRepo.border,
	borderColor: PropTypesRepo.borderColor,
	h: PropTypesRepo.h,
	w: PropTypesRepo.w,
	maxH: PropTypesRepo.maxH,
	maxW: PropTypesRepo.maxW,
	minW: PropTypesRepo.minW,
	minH: PropTypesRepo.minH,
	cursor: PropTypesRepo.cursor,
	bg: PropTypesRepo.bg,
	textColor: PropTypesRepo.textColor,
	textWeight: PropTypesRepo.textWeight,
	textAlign: PropTypesRepo.textAlign,
	textSize: PropTypesRepo.textSize,
	fontFamily: PropTypesRepo.fontFamily,
	shadow: PropTypesRepo.shadow,
	transition: PropTypesRepo.transition,
	hoverBg: PropTypesRepo.hoverBg,
	hoverTextColor: PropTypesRepo.hoverTextColor,
	hoverBorderColor: PropTypesRepo.hoverBorderColor,
	hoverShadow: PropTypesRepo.hoverShadow,
	focusBorderColor: PropTypesRepo.focusBorderColor,
};

/* eslint-enable react/require-default-props */

Textarea.defaultProps = {
	d: 'flex',
	p: { x: '12px', y: '8px' },
	textSize: 'body',
	rounded: 'md',
	border: '1px solid',
	borderColor: 'gray500',
	h: '104px',
	w: '100%',
	minW: '100%',
	bg: 'white',
	textColor: 'dark',
	textWeight: '500',
	focusBorderColor: 'gray700',
	loadingIcon: <Icon name="Loading" pos="absolute" top="12px" right="12px" size="16px" />,
};

export default Textarea;
